export default __webpack_public_path__ + "static/media/img-0551-denmark-full-face.d981632d.png";